import * as React from "react";
import { Link } from "react-router-dom";
import AutoOcrStore from "../../../../stores/AutoOcrStore";
import FormTypeStore from "../../../../stores/FormTypeStore";
import { GetAutoOcrDocumentTypeList } from "../../../../actions/AutoOcrActions";
import { GetAllFormTypes } from "../../../../actions/FormTypeActions";
import actionTypes from "../../../../actions/ActionTypes";
import aiIcon from "../../../../images/TD AI Icon 2 Color.png";
class AutoOcrSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      documentTypeList: [],
      formTypeList: []
    };
    this.onReceiveDocumentTypeChange = this.onReceiveDocumentTypeChange.bind(this);
    this.onReceiveFormTypeChange = this.onReceiveFormTypeChange.bind(this);
  }
  componentDidMount() {
    AutoOcrStore.addChangeListener(this.onReceiveDocumentTypeChange);
    FormTypeStore.addChangeListener(this.onReceiveFormTypeChange);
    GetAutoOcrDocumentTypeList();
    GetAllFormTypes();
  }
  componentWillUnmount() {
    AutoOcrStore.removeChangeListener(this.onReceiveDocumentTypeChange);
    FormTypeStore.addChangeListener(this.onReceiveFormTypeChange);
  }
  onReceiveDocumentTypeChange() {
    let lastChange = AutoOcrStore.lastChange();
    if (lastChange === actionTypes.AutoOcrDocumentTypeGetList) {
      let documentTypes = AutoOcrStore.getDocumentTypes();
      this.setState({
        documentTypeList: documentTypes
      });
    }
    if (lastChange === actionTypes.AutoOcrDataUpdate) {
      GetAutoOcrDocumentTypeList();
    }
  }
  onReceiveFormTypeChange() {
    let lastChange = FormTypeStore.getLastAction();
    if (lastChange.actionType === "FTGetAll") {
      let formTypes = FormTypeStore.getAllFormTypes();
      this.setState({
        formTypeList: formTypes
      });
    }
  }
  render() {
    let documentTypes;
    if (this.state.documentTypeList !== void 0) {
      documentTypes = this.state.documentTypeList.map((docType) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "8px" }, key: docType.id }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/AutoOCRDocumentType/" + docType.id,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-file-invoice" }),
        " ",
        docType.name
      )));
    } else {
      documentTypes = /* @__PURE__ */ React.createElement("div", null, "No Auto Ocr defined");
    }
    let formTypes;
    if (this.state.formTypeList !== void 0) {
      formTypes = this.state.formTypeList.map((formType) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "8px" }, key: `formType-` + formType.formTypeId }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/AutoOCRMapping/" + formType.formTypeId,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        formType.name
      )));
    } else {
      documentTypes = /* @__PURE__ */ React.createElement("div", null, "No configurations defined");
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "245px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/AutoOcrDocumentType",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement("img", { src: aiIcon, className: "aiMenuIcon2", alt: "aiIcon" }), " ", "   ", "Auto OCR")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "50%", overflow: "auto" } }, documentTypes),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/AutoOCRDocumentType/0" }, "New Document Type"),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("span", { className: "fs-6" }, "Auto Ocr Form Type configuration"),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "50%", overflow: "auto" } }, formTypes)
    );
  }
}
export default AutoOcrSidebar;
